$('.hotspot__button').on('click', function(e){
  if(!$(this).parents('.hotspot').hasClass('hotspot--selected'))
  {
    $(this).parents('.hotspot-container').find('.hotspot').removeClass('hotspot--selected');
    $(this).parent('.hotspot').addClass('hotspot--selected');
    $(this).parent('.hotspot').find('.hotspot__label').removeClass('hidden');
  }
  else
  {
    $(this).parent('.hotspot').removeClass('hotspot--selected');
    $(this).parent('.hotspot').find('.hotspot__label').addClass('hidden');
  }
  e.preventDefault();
});



// WEBPACK FOOTER //
// ./scripts/block-hotspot-image.js